import { render, staticRenderFns } from "./UserExternalAccessKey.vue?vue&type=template&id=12f6c2ed"
import script from "./UserExternalAccessKey.vue?vue&type=script&lang=js"
export * from "./UserExternalAccessKey.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports